// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1WTPc","boxTitle":"Qualiphy_boxTitle__37hzd","box":"Qualiphy_box__2vmZD","toggleWrap":"Qualiphy_toggleWrap__3Bah4"};